export default __webpack_public_path__ + "site-icons/android-chrome-512x512.png";